import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Snackbar,
  Alert
} from '@mui/material';
import {
  Refresh as RefreshIcon,
  Warning as WarningIcon,
  CheckCircle as SuccessIcon,
  Error as ErrorIcon,
  BugReport as DiagnosticIcon
} from '@mui/icons-material';

interface DiagnosticResult {
  category: string;
  status: 'success' | 'warning' | 'error';
  message: string;
  details?: any;
}

const DrawerDiagnostics: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [diagnostics, setDiagnostics] = useState<DiagnosticResult[]>([]);
  const [rawData, setRawData] = useState<any>({});
  const [confirmDialog, setConfirmDialog] = useState<{
    open: boolean;
    title: string;
    message: string;
    onConfirm: () => void;
  }>({
    open: false,
    title: '',
    message: '',
    onConfirm: () => {}
  });

  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity: 'success' | 'error' | 'warning' | 'info';
  }>({
    open: false,
    message: '',
    severity: 'info'
  });

  const runDiagnostics = async () => {
    setLoading(true);
    setDiagnostics([]);

    try {
      const date = new Date(selectedDate);
      console.log('🔍 بدء تشخيص الخزينة للتاريخ:', selectedDate);

      // استخدام الخدمة المحسنة للمقارنة
      // const comparisonResult = await compareDrawerCalculations(date);
      // const { newCalculation, oldReport, comparison, allMatch } = comparisonResult;

      // إضافة نتائج التشخيص
      // if (allMatch) {
      //   setDiagnostics([{
      //     category: 'عام',
      //     status: 'success',
      //     message: '✅ جميع الحسابات صحيحة! لا توجد مشاكل في الخزينة.',
      //     details: { allMatch: true, summary: newCalculation.summary }
      //   }]);
      // } else {
      //   // تشخيص المبيعات
      //   setDiagnostics(prev => [...prev, {
      //     category: 'المبيعات',
      //     status: comparison.sales.match ? 'success' : 'error',
      //     message: comparison.sales.match
      //       ? `✅ حساب المبيعات صحيح: ${comparison.sales.new} جنيه`
      //       : `❌ خطأ في حساب المبيعات: محسوب ${comparison.sales.new} vs مُبلغ ${comparison.sales.old}`,
      //     details: comparison.sales
      //   }]);

      //   // تشخيص الصيانة
      //   setDiagnostics(prev => [...prev, {
      //     category: 'الصيانة',
      //     status: comparison.maintenance.match ? 'success' : 'error',
      //     message: comparison.maintenance.match
      //       ? `✅ حساب الصيانة صحيح: ${comparison.maintenance.new} جنيه`
      //       : `❌ خطأ في حساب الصيانة: محسوب ${comparison.maintenance.new} vs مُبلغ ${comparison.maintenance.old}`,
      //     details: comparison.maintenance
      //   }]);

      //   // تشخيص المصاريف
      //   setDiagnostics(prev => [...prev, {
      //     category: 'المصاريف',
      //     status: comparison.expenses.match ? 'success' : 'error',
      //     message: comparison.expenses.match
      //       ? `✅ حساب المصاريف صحيح: ${comparison.expenses.new} جنيه`
      //       : `❌ خطأ في حساب المصاريف: محسوب ${comparison.expenses.new} vs مُبلغ ${comparison.expenses.old}`,
      //     details: comparison.expenses
      //   }]);

      //   // تشخيص صافي الربح
      //   setDiagnostics(prev => [...prev, {
      //     category: 'صافي الربح',
      //     status: comparison.netProfit.match ? 'success' : 'error',
      //     message: comparison.netProfit.match
      //       ? `✅ حساب صافي الربح صحيح: ${comparison.netProfit.new} جنيه`
      //       : `❌ خطأ في حساب صافي الربح: محسوب ${comparison.netProfit.new} vs مُبلغ ${comparison.netProfit.old}`,
      //     details: comparison.netProfit
      //   }]);

      //   // إضافة تفاصيل إضافية
      //   setDiagnostics(prev => [...prev, {
      //     category: 'تفاصيل إضافية',
      //     status: 'warning',
      //     message: `📊 تفاصيل الحساب الجديد: نقدي ${newCalculation.summary.totalCashIncome} + دين ${newCalculation.summary.totalDebtIncome}`,
      //     details: {
      //       cashFlow: newCalculation.summary.netCashFlow,
      //       salesBreakdown: newCalculation.sales,
      //       maintenanceBreakdown: newCalculation.maintenance
      //     }
      //   }]);
      // }

      console.log('🔍 انتهى التشخيص');

    } catch (error) {
      console.error('❌ خطأ في التشخيص:', error);
      setDiagnostics([{
        category: 'عام',
        status: 'error',
        message: `❌ فشل في التشخيص: ${error}`,
        details: { error: error?.toString() }
      }]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    runDiagnostics();
  }, []);

  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'success': return <SuccessIcon color="success" />;
      case 'warning': return <WarningIcon color="warning" />;
      case 'error': return <ErrorIcon color="error" />;
      default: return <DiagnosticIcon />;
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'success': return 'success';
      case 'warning': return 'warning';
      case 'error': return 'error';
      default: return 'default';
    }
  };

  return (
    <Box sx={{ p: 3, maxWidth: 1200, mx: 'auto' }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          🔍 تشخيص حسابات الخزينة
        </Typography>
        <Alert severity="info" sx={{ my: 4 }}>
          تم حذف منطق الدرج القديم بالكامل. أداة التشخيص غير متاحة حالياً بعد إعادة بناء الخزينة.
        </Alert>
      </Paper>
    </Box>
  );
};

export default DrawerDiagnostics;
